
export default {
  state: {
    Userding: [],
    modules: {}, //菜单折叠
    // phoneModules: [], //菜单折叠
  },
  mutations: {
    setmodules(state, { moduleKey, key }) {
      let oldState = state.modules[moduleKey] || {};
      oldState[key] = !oldState[key];

      state.modules = Object.assign(state.modules, { [moduleKey]: oldState })
    },

    setUserding(state, val) {
      let arrDing = state.Userding;
      if (Array.isArray(val)) {
        arrDing = val;
      } else {
        let _index = arrDing.findIndex((p) => p.name === val.name);
        if (_index === -1) {
          arrDing.push(val);
        } else {
          arrDing.splice(_index, 1);
        }
      }
      state.Userding = arrDing;
    },
  },
  actions: {
    async saveDing({ state, commit }, val) {
      commit('setUserding', val);
      return await this.$app.curl.post("/api/core/personal/saveDing", { Userding: state.Userding })
    }
  }
}